import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

// Shown whenever the API is unreachable or returns nothing — mirrors the
// backend seed so the section never disappears from the page.
const FALLBACK_TESTIMONIALS = [
  { id: "fb-1", name: "Leon K.", text: "8 weeks in and my shoulders finally pop. The coaching cues alone are worth the price — never felt my back work like this before.", rating: 5 },
  { id: "fb-2", name: "Marco S.", text: "Bought it as a broke student, best 20€ I've spent. The progressive overload log keeps me honest. Up 6kg lean since starting.", rating: 5 },
  { id: "fb-3", name: "Jannis R.", text: "Trained for 2 years with random YouTube plans and looked the same. This split actually has structure. Chest and arms blew up in cycle one.", rating: 4 },
  { id: "fb-4", name: "Timo B.", text: "The supplement guide saved me so much money — cut half the junk I was buying. Program is brutal but the results speak for themselves.", rating: 5 },
];

export const Testimonials = () => {
  const [items, setItems] = useState(FALLBACK_TESTIMONIALS);

  useEffect(() => {
    api
      .get("/testimonials")
      .then((r) => { if (Array.isArray(r.data) && r.data.length) setItems(r.data); })
      .catch(() => {});
  }, []);

  return (
    <section className="py-24 sm:py-32 bg-[#0A0A0A] border-y border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="section-label mb-4">// SURVIVORS SPEAK //</p>
        <h2 className="font-anton text-4xl sm:text-5xl uppercase tracking-tight mb-16">
          They weren't <span className="neon-text">done yet</span> either
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((t) => (
            <div key={t.id} data-testid={`testimonial-${t.id}`} className="card-ady p-6 flex flex-col">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} size={14} className="fill-[#39FF14] text-[#39FF14]" />
                ))}
              </div>
              <p className="text-[#A1A1AA] text-sm leading-relaxed flex-1">"{t.text}"</p>
              <p className="font-bebas tracking-[0.2em] text-[#D90429] mt-5">— {t.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
